import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/pages/Index.jsx";
import MentionsLegales from "./components/pages/MentionsLegales.jsx";
import "./components/mentions-legals/mentions-legal.css";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
    </Routes>
  );
}
